module.exports = __webpack_public_path__ + "img/contrend-login.7e99de28.png";